import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getRequiredResourceList } from '../../utils/index.tsx';

const sessionStorage = createSessionStorageProvider('', false);
const JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
const buildWebResourcesPayload = (resourceArr: Array<string>) => {
	const payload = {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		r: [] as string[],
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		c: [] as string[],
		xc: [JIRA_HERITAGE_CRITICAL_BATCH],
		xr: [],
	};

	// On the client side we need to avoid fetching any contexts that WRM has already loaded

	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	if (window.require) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const requireHandlerWrapper = window.require('wrm/require-handler-wrapper');
		const requireHandler = requireHandlerWrapper?.getRequireHandler();
		if (requireHandler) {
			const prefetchedResources = requireHandler?.requireHandlerV2?._cache
				.getExclusionLists() // eslint-disable-next-line @typescript-eslint/no-explicit-any
				.context?.filter((item: any) => item !== JIRA_HERITAGE_CRITICAL_BATCH);

			payload.xc = payload.xc.concat(prefetchedResources);
		}
	}

	resourceArr.forEach((resource) => {
		if (resource.indexOf('wrc!') !== -1) {
			payload.c.push(resource.slice(4));
		} else if (resource.indexOf('wr!') !== -1) {
			payload.r.push(resource.slice(3));
		} else {
			payload.r.push(resource);
		}
	});

	return payload;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setResourceUrl = (resourceUrl: any) => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		sessionStorage.set('classicBatchUrl', JSON.stringify(resourceUrl));
	} else {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.sessionStorage.setItem('classicBatchUrl', JSON.stringify(resourceUrl));
	}
};

const removeResourceUrl = () => {
	if (fg('jfp-vulcan-browser-storage-migration')) {
		sessionStorage.remove('classicBatchUrl');
	} else {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		window.sessionStorage.removeItem('classicBatchUrl');
	}
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const addPrefetchLinkstoDOM = (batchUrl: any) => {
	// @ts-expect-error - TS7006 - Parameter 'resource' implicitly has an 'any' type.
	batchUrl.resources.forEach((resource) => {
		const { url, resourceType } = resource;

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const linkTag = document.createElement('link');
		linkTag.href = url;

		if (resourceType === 'CSS') {
			// excluding CSS because CSS prefetching causes the board to load
			// in a funny way. No workaround known and decided to exclude as
			// impact will be low.
			return;
		}
		linkTag.rel = 'prefetch';
		linkTag.as = 'script';

		// inject links in the head of the document

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		document.head.appendChild(linkTag);
	});
};

const getRapidBoardAppResources = async () => {
	const contexts = getRequiredResourceList('rapidboard-board');
	const payload = buildWebResourcesPayload(contexts);

	try {
		const res = await fetchJson('/rest/webResources/1.0/resources?operation=FetchWRMData', {
			method: 'POST',
			body: JSON.stringify(payload),
		});

		// store the resource Url to avoid resource endpoint call when transitioning to rapidboards
		setResourceUrl(res);
		// Add prefetch links to the DOM
		addPrefetchLinkstoDOM(res);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// If prefetch fails, don't throw error on other's page. Instead log it and continue.
		removeResourceUrl();
		log.safeErrorWithoutCustomerData(
			'spa.view.routes.classic-projects.work-all-data.getData',
			'An error was thrown while prefetching work all data',
			error,
		);
	}
};

export default getRapidBoardAppResources;
